<capra-toast class="progress-toast" type="processing">
	<h4 class="toast-header">Creating Dataset in your Personal content</h4>
	<p class="toast-text">Stay on this page to be notified when the data is ready to use</p>
</capra-toast>
